import { InitialState } from '../initialState';

const CandidateReducer = (state = InitialState, action) => {
    switch (action.type) {
        case 'FETCH_PROFILE':
            return {
                ...state,
                candidateProfile: action.payload,
            };
        case 'FETCH_STATUS':
            return {
                ...state,
                candidateStatus: action.payload,
            };
        case 'FETCH_JOBS_APPLIED':
            return {
                ...state,
                candidateJobsApplied: action.payload,
            };
        case 'FETCH_CANDIDATE_INFO':
            return {
                ...state,
                candidateInfo: action.payload,
            };
        case 'FETCH_DOCUMENT_UPLOAD':
            return {
                ...state,
                candidateUploadedDocs: action.payload,
            };
        

        default:
            return state;
    }
};

export default CandidateReducer;
